/* global jQuery google */

// eslint-disable-next-line no-unused-vars
function initMap() { }

; (function ($) {
	/*
	 *  initMap
	 *
	 *  Will be fired when the Google Maps API has loaded, reassigns global function
	 */

	const style = [
		{
			featureType: 'landscape.man_made',
			elementType: 'all',
			stylers: [{ color: '#ffffff' }]
		},
		{
			featureType: 'landscape.natural',
			elementType: 'all',
			stylers: [{ color: '#daf7e3' }]
		},
		{
			featureType: 'road',
			stylers: [
				{
					visibility: 'simplified'
				}
			]
		},
		{
			featureType: 'road.highway',
			elementType: 'geometry.fill',
			stylers: [{ color: '#a4b3cb' }]
		},
		{
			featureType: 'road.local',

			stylers: [{ visibility: 'simplified' }]
		},

		{
			featureType: 'road.arterial',
			elementType: 'geometry.fill',
			stylers: [{ color: '#c4c2d5' }]
		},

		{
			featureType: 'road',
			elementType: 'labels',
			stylers: [{ visibility: 'off' }]
		},

		{
			featureType: 'transit',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},
		{
			featureType: 'poi',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off'
				}
			]
		},

		{
			featureType: 'water',
			stylers: [
				{
					color: '#a0d8eb'
				},
				{
					visibility: 'simplified'
				}
			]
		}
	];



	// eslint-disable-next-line no-func-assign
	initMap = function () {
		$('.google-map').each(function () {
			newMap($(this))
		})
	}

	/*
	 *  render a Google Map onto the selected jQuery element
	 */
	function newMap($el) {
		var $markers = $el.find('.marker')
		var args = {
			zoom: parseInt($el.data('zoom')),
			// center: new google.maps.LatLng($el.context.dataset.centerLat, $el.context.dataset.centerLng),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			styles: style
		}
		var map = new google.maps.Map($el[0], args)
		map.markers = []
		$markers.each(function () {
			addMarker($(this), map)
		})

		centerMap(map)

		return map
	}

	/*
	 *  add a marker to the selected Google Map
	 */
	function addMarker($marker, map) {
		var latlng = new google.maps.LatLng(
			$marker.attr('data-lat'),
			$marker.attr('data-lng')
		)
		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: new google.maps.MarkerImage($marker.attr('data-icon'))
		})
		map.markers.push(marker)
		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			})
			google.maps.event.addListener(marker, 'click', function () {
				infowindow.open(map, marker)
			})
		}
	}

	/**
	 *  center the map, showing all markers attached
	 */
	function centerMap(map) {
		var bounds = new google.maps.LatLngBounds()
		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {
			var latlng = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng()
			)
			bounds.extend(latlng)
		})
		if (map.markers.length === 1) {
			map.setCenter(bounds.getCenter())
		} else {
			map.fitBounds(bounds)
		}
	}
})(jQuery)
